import { useEffect } from 'react';
import { useGlobalWebSocket } from '../contexts/GlobalWebSocketContext';
import { useUnreadMessagesContext } from '../contexts/UnreadMessagesContext';
import useBrowserNotifications from '../hooks/useBrowserNotifications';

const BackgroundChatListener = ({ tripId, currentUser, onUnreadCountChange, tripTitle = '' }) => {
  const { addEventListener, subscribeToTrip, unsubscribeFromTrip } = useGlobalWebSocket();
  const { showChatNotification, permission } = useBrowserNotifications();
  const { refresh } = useUnreadMessagesContext();

  // Subscribe to the trip when component mounts
  useEffect(() => {
    if (subscribeToTrip) {
      subscribeToTrip(tripId);
    }
    
    return () => {
      if (unsubscribeFromTrip) {
        unsubscribeFromTrip(tripId);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripId]); // Only depend on tripId to prevent infinite subscription loops

  // Handle new messages
  useEffect(() => {
    if (!addEventListener) return;

    const removeListener = addEventListener('message', (data) => {
      if (data.type === 'message' && 
          data.message.trip_id === tripId && 
          data.message.user_id !== currentUser?.id) {
        
        // Trigger refresh of global unread counts - this will persist across pages
        if (refresh) {
          refresh();
        }
        
        // Notify parent for any local UI updates
        if (onUnreadCountChange) {
          onUnreadCountChange();
        }

        // Show browser notification
        if (permission === 'granted') {
          showChatNotification(
            data.message.sender_name,
            data.message.content,
            tripTitle
          );
        }
      }
    });

    return removeListener;
  }, [addEventListener, tripId, currentUser?.id, onUnreadCountChange, permission, showChatNotification, tripTitle, refresh]);

  return null; // This component doesn't render anything
};

export default BackgroundChatListener; 